
export default () => {

    const header = document.querySelector('header')
    if(!header) return

    const height = header.getBoundingClientRect().height

    const setDirection = () => window.scrollY > y ? false : true

    let up = setDirection()
    let y =  window.scrollY

    window.addEventListener('scroll', () => {
        up = setDirection()
        y =  window.scrollY

        const method = (!up && y > height) ? 'add' : 'remove'
        header.classList[method]('out')
    })
}
